import React from 'react';
import {Link, useHistory} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import WaveSelect from './WaveSelect';
import DeleteWaveButton from './DeleteWaveButton';
import {useDispatch} from 'react-redux';
import {surveyWaveDeleteSuccess} from '../../../actions/action_survey_wave';

const WaveToolbar = ({survey, wave, warning}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const handleChange = React.useCallback((e) => {
        const newWaveId = e.target.value;
        history.push(`/surveys/${survey.id}/trackers/wave/${newWaveId}`);
    }, [history, survey.id]);

    const handleDelete = React.useCallback(() => {
        const newWaves = survey.waves.filter((w) => w.id !== wave.id);
        const lastWave = newWaves[newWaves.length - 1];
        history.push(`/surveys/${survey.id}/trackers/wave/${lastWave.id}`);
        dispatch(surveyWaveDeleteSuccess(newWaves));
    }, [dispatch, history, wave, survey]);

    if (survey.waves.length < 2) {
        return (
            <Link className="btn btn-outline-primary" to={`/surveys/${survey.id}/trackers/wave/create`}>
                <FormattedMessage {...messages.waves.button.create} />
            </Link>
        );
    }
    return (
        <div className="input-group">
            <div className="input-group-prepend">
                <label className="input-group-text" htmlFor="wave-toolbar-selector"><FormattedMessage {...messages.waves.label.select} /></label>
            </div>
            <WaveSelect value={wave} items={survey.waves} onChange={handleChange} className="form-control" id="wave-toolbar-selector" />
            <div className="input-group-append">
                <Link className="btn btn-outline-primary" to={`/surveys/${survey.id}/trackers/wave/${wave.id}/edit`}>
                    <FormattedMessage {...messages.waves.button.edit} />
                </Link>
                <Link className="btn btn-outline-primary" to={`/surveys/${survey.id}/trackers/wave/create`}>
                    <FormattedMessage {...messages.waves.button.create} />
                </Link>
                <DeleteWaveButton wave={wave} survey={survey} warning={warning} handleDelete={handleDelete}>
                    <button className="btn btn-primary delete-button" type="button">
                        <FormattedMessage {...messages.waves.button.delete} />
                    </button>
                </DeleteWaveButton>
            </div>
        </div>
    );
};

export default WaveToolbar;
